<div class='wrapperInfiniteLoading'>
  <spinner *ngIf='showSpinner'></spinner>
  <!--  // пока не удалять. возможно понадобится текст показывать-->
  <!--  <div *ngIf='showText_contentEnded' class='wrapperInfiniteLoading__contentEnded'>All content is loaded</div>-->
</div>